import { getTranslation } from './translations';
import { defaultThemeName } from '../../config/defaults';

const themeMap = new Map();
themeMap.set("Default", require('./themes/default').default);

/**
 * returns theme object
 * @param {string} name internal name
 */

export function getLastUsedColorsFromFile(name) {
    const theme = themeMap.get(name);
    const themeColors = theme.colors.join('|');
    return themeColors;
}

export function getThemeSettings(name) {
    const theme = themeMap.get(name);
    if (!theme || !theme.themeSettings || !(theme.themeSettings instanceof Object)) {
        console.warn(`Theme name:${name} doesn't exist or has no themeSettings field`)
        return themeMap.get(defaultThemeName).themeSettings;
    }
    return theme.themeSettings;
}

export function changeSettingsValueInAllThemes(settingsName, newValue) {
    for (const theme of themeMap) {
        theme[1].themeSettings[settingsName] = newValue;
    }
    
    const newTemplateSettings = getThemeSettings(localStorage.getItem('onlineCreatorB2B-currentThemeName'));
    localStorage.setItem('onlineCreatorB2B-settings', JSON.stringify(newTemplateSettings));
}

/**
 * returns localized theme name
 * @param {string} name internal name
 */
export function getLocalizedThemeName(name) {
    const theme = themeMap.get(name);
    if (!theme) {
        return 'NULL';
    }
    return getTranslation("Theme_"+name);
}

export function getLocalizedThemeMainColors(name) {
    const theme = themeMap.get(name);
    if (!theme) {
        return 'NULL';
    }
    if(!theme.mainColors) {
        return theme.localizedMainColors || "NULL";
    }
    let colorString = getTranslation("Color_"+theme.mainColors[0]);
    for (const color of theme.mainColors.slice(1))
    {
        colorString = colorString+`, ${getTranslation("Color_"+color)}`;
    }
    return colorString;

}

export function getThemeIconPath(name) {
    const theme = themeMap.get(name);
    if (!theme) {
        return '';
    }
    return  `./img/icons/theme/${theme.iconName || "NULL"}`;
}

export function getThemeNameList() {
    return Array.from(themeMap.keys());
}

export function themeExists(themeName) {
    return !!themeMap.get(themeName);
}